import {
  App,
  DEFAULT_LAUFZEIT_YEARS,
  isValidLaufzeit,
  pickLongestVorbelegungLaufzeit,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { AddVertragToAngebote } from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';

function resolveBaselineLaufzeit(
  payload: AddVertragToAngebote,
  sectionState: Vertragsoptionen,
): number {
  const fromVorbelegung = pickLongestVorbelegungLaufzeit(payload.vorvertragsNummern);
  if (fromVorbelegung !== undefined) {
    return fromVorbelegung;
  }
  if (isValidLaufzeit(sectionState?.ausgewaehltevertragslaufzeit)) {
    return sectionState.ausgewaehltevertragslaufzeit;
  }
  if (isValidLaufzeit(sectionState?.vertragslaufzeit)) {
    return sectionState.vertragslaufzeit;
  }
  return DEFAULT_LAUFZEIT_YEARS;
}

function applyDatesAndLaufzeit(
  newState: Vertragsoptionen,
  sectionState: Vertragsoptionen,
  actionPayload: AddVertragToAngebote,
): void {
  const currentDateObj = dayjs();
  const beginnDateObj = dayjs(sectionState.beginnDatum, DATEFORMAT_LOCAL_STATE);
  const aenderungDateObj = dayjs(sectionState.aenderungdatum, DATEFORMAT_LOCAL_STATE);
  newState.beginnDatum = currentDateObj.isAfter(beginnDateObj)
    ? currentDateObj.add(1, 'day').format(DATEFORMAT_LOCAL_STATE)
    : sectionState.beginnDatum;
  newState.aenderungdatum = currentDateObj.isAfter(aenderungDateObj)
    ? currentDateObj.add(1, 'day').format(DATEFORMAT_LOCAL_STATE)
    : sectionState.aenderungdatum;
  const laufzeit = resolveBaselineLaufzeit(actionPayload, sectionState);
  newState.vertragslaufzeit = laufzeit;
  newState.ausgewaehltevertragslaufzeit = laufzeit;
}

export const addVorvertragToAngeboteReducer = function(
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  appId: App,
  angebotsId?: string
): Vertragsoptionen {
  const actionPayload: AddVertragToAngebote = action.payload;
  if (actionPayload.appId === appId && actionPayload.angebotsId === angebotsId) {
    const newState: Vertragsoptionen = cloneDeep(sectionState);
    newState.vorvertragsNummern = actionPayload.vorvertragsNummern;
    newState.vorvertragSofortschutz = actionPayload.vorvertragSofortschutz;
    newState.beibehalten = actionPayload.beibehalten;
    newState.angebotsdatum = newState.angebotsdatum
      ? newState.angebotsdatum
      : actionPayload.angebotsdatum;
    if (newState.beibehalten) {
      newState.zahlungsweise = actionPayload.zahlweise;
    }

    if (actionPayload.linieOfVorvertrag) {
      newState.vorvertragLinie = actionPayload.linieOfVorvertrag;
    }

    if (actionPayload.vertragskennzeichen) {
      newState.vertragskennzeichen = actionPayload.vertragskennzeichen;
    }

    newState.isWeitererVertrag = Boolean(
      actionPayload.vorvertragForVorbelegung?.vertragsnummer &&
        !actionPayload.vorvertragForVorbelegung?.spLaufnummer,
    );
    newState.weitereVertraege = actionPayload.vorvertragsNummern.filter(
      value => !value.spLaufnummer,
    );

    if (!sectionState.beibehalten) {
      applyDatesAndLaufzeit(newState, sectionState, actionPayload);
    }
    return newState;
  }
  return sectionState;
};
